<template>
    <p class="m-0">
      {{ formattedPrice }}
    </p>
  </template>
  
  <script setup lang="ts">
  import { computed } from 'vue';
  
  
  const props = defineProps({
    amount: {
      type: String,
      required: true
    },
    
  });

  
  
  const formattedPrice = computed(() => {
    const price = parseFloat(props.amount) || 0;
    const formatted = Intl.NumberFormat('nl-NL', {
      style: 'currency',
      currency: 'EUR',
      currencyDisplay: 'narrowSymbol',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(price);
    return formatted.replace(/\s/g, '');
  });
  </script>